import { Link } from 'react-router-dom';
import { useLocale, withLocale } from '../i18n';

export default function NotFound() {
  const locale = useLocale();
  return (
    <section className="section" style={{ paddingTop: 160, minHeight: '60vh', display: 'flex', alignItems: 'center' }}>
      <div className="container" style={{ textAlign: 'center' }}>
        <h1>404</h1>
        <p className="body-lg">This page doesn't exist.</p>
        <Link className="btn btn-primary" to={withLocale('/', locale)}>
          Back home
        </Link>
      </div>
    </section>
  );
}
